export const locationTypes = {
  loading: 'locations/loading',
  success: 'locations/success',
  error: 'locations/error',
  save: 'locations/save',
  add: 'locations/add',
  delete: 'locations/delete',
};
